var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ConversionDetailContent',{attrs:{"s-transaction-id":_vm.$route.params.sTransactionId},on:{"close":function($event){return _vm.$router.go(-1)},"go-to-payment":_vm.goToPayment,"go-to-invoice":_vm.goToInvoice}})
}
var staticRenderFns = []

export { render, staticRenderFns }